'use client';
import {createGlobalStyle} from "styled-components";
import reset from "styled-reset";
import {SIZES} from "@/components/constants";

const GlobalStyle = createGlobalStyle`
    ${reset}
    @font-face {
        font-family: 'Pretendard';
        font-weight: 100;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Thin.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 200;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-ExtraLight.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 300;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Light.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 400;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Regular.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 500;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Medium.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 600;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-SemiBold.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 700;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Bold.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 800;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-ExtraBold.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 900;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Black.woff2') format('woff2');
    }
    @font-face {
        font-family: 'Marcellus SC';
        font-style: normal;
        font-weight: 400;
        src: local('Marcellus SC'), url('https://fonts.cdnfonts.com/s/16031/MarcellusSC-Regular.woff') format('woff');
    }
    @font-face {
        font-family: 'Material Symbols Rounded';
        font-style: normal;
        font-weight: 400;
        src: url(https://fonts.gstatic.com/s/materialsymbolsrounded/v309/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rIelXxeJKJBiCa8.woff2) format('woff2');
    }

    .material-symbols-rounded {
        font-family: 'Material Symbols Rounded' !important;
        font-weight: normal;
        font-style: normal;
        font-size: 24px;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        word-wrap: normal;
        direction: ltr;
        -webkit-font-feature-settings: 'liga';
        -webkit-font-smoothing: antialiased;
    }



    *, *::before, *::after {
        box-sizing: border-box;
    }

    * {
        font-family: 'Pretendard', sans-serif !important;
        
    }
    html, body { height: 100%; }
    html, body * {line-height: 1.5;}


    button {
        cursor: pointer;
        background: none;
        border: 0;
        outline: 0;
        padding: 0;
    }

    a {
        text-decoration: none;
        color: inherit;
        cursor: pointer;
    }

    img {
        max-width: 100%;
    }

    div.table-grid-wrap {
        border-bottom: 1px solid #EEE;
        display: flex;
        align-items: center;

        &:first-of-type {
            border-top: 1px solid #EEE;
        }

        div.row {
            flex: 1;
            display: flex;
            align-items: center;

            div.name {
                display: flex;
                align-items: center;
                gap: 4px;
                flex-basis: 120px;
                padding: 13px 20px;
                background-color: #FAFAFA;
                min-height: 48px;

                color: #555;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }

            div.contents {
                padding: 8px 16px;
                flex: 1;
                background-color: #fff;
                height: 48px;
            }
        }
    }

    
`;
export function setScreenHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
export default GlobalStyle;
